import { ReactComponent as Dice } from '../../images/icon-dice.svg'

import "./Button.scss"
const Button = ({ onClick }) => {
    return (
        <div className='btn-container'>
            <button onClick={onClick} className='btn'>
                <Dice></Dice>
            </button>
        </div>
    )
}

export default Button